var Breadcrumb = (function () {
    function Breadcrumb() {
    }
    return Breadcrumb;
}());
export { Breadcrumb };
//# sourceMappingURL=breadcrumb.js.map


//////////////////
// WEBPACK FOOTER
// /var/www/dnata-cerf-front-end/releases/20200326161233/~/angular-crumbs/breadcrumb.js
// module id = 0Ixm
// module chunks = 4